/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    homework_id: number;
    page?: number;
    size?: number;
}

type IOutput = IUserInfo[];

export const getTimelineStatUserList = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.TIMELINE_STAT_USER_LIST, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});
